import { publicFetch } from "api/publicFetch";

/**
 * @typedef {{timeZones: [{label: string; value: number}]}} Timezones
 */

/**
 * Get Timezones
 * @param {string} code Country code
 * @returns {Promise<Response>} Timezones
 */
const getTimezones = async (code) => {
  const { data } = await publicFetch.get(`/timezones/countrycode=${code}`);
  return data;
};

export default getTimezones;
